<template>
    <component :is="template">
        <v-responsive width="100%">
            <v-card elevation="0" tile max-width="100%">
                <v-card-title class="tit tit--lg">
                    <span class="py-4 pl-4"><b>교환하기</b></span>
                </v-card-title>
            </v-card>

            <v-card elevation="0" tile max-width="100%">
                <template v-for="cart, index in carts">
                    <v-divider :key="index"/>
                    <pickup-item :key="cart._id" :cart="cart" />
                </template>

                <v-divider/>

                <v-card-text>
                    <v-layout>
                        <v-flex grow-shrink-0>총 상품가격</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>{{ saleAmount.format() }} 원</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex grow-shrink-0>총 배송비</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>{{ shippingAmount.format() }} 원</v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex grow-shrink-0>도서산간 할증</v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0>{{ islandAmount.format() }} 원</v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider/>

                <v-card-text>
                    <v-layout>
                        <v-flex grow-shrink-0><b>총 결제 예상 금액</b></v-flex>
                        <v-spacer/>
                        <v-flex grow-shrink-0><b>{{ totalAmount.format() }} 원</b></v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card v-show="false" tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">구매자 정보 입력</v-card-title>
                <v-card-text>
                    <v-text-field v-model="exchangeOrder.buyer.name" label="이름" persistent-placeholder hide-details/>

                    <v-row no-gutters align="center">
                        <v-col>
                            <v-select v-model="exchangeOrder.buyer.phone1" v-bind="$attrs" :items="phones" label="연락처" persistent-placeholder hide-details class="mt-4" />
                        </v-col>
                        <v-icon small class="mt-4">mdi-minus</v-icon>
                        <v-col>
                            <v-text-field v-model="exchangeOrder.buyer.phone2" v-bind="$attrs" hide-details maxlength="4" class="mt-4" />
                        </v-col>
                        <v-icon small class="mt-4">mdi-minus</v-icon>
                        <v-col>
                            <v-text-field v-model="exchangeOrder.buyer.phone3" v-bind="$attrs" hide-details maxlength="4" class="mt-4" />
                        </v-col>
                    </v-row>

                    <v-text-field v-model="exchangeOrder.buyer.email" label="이메일" persistent-placeholder hide-details class="mt-4" />
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">교환 수단</v-card-title>
                <v-card-text>
                    <v-text-field v-model="exchangeOrder.pno" label="핀번호" outlined persistent-placeholder dense maxLength="20" rows="3" hide-details/>
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">수취인 정보 입력</v-card-title>
                <v-card-text>
                    <v-text-field v-model="exchangeOrder.receiver.name" label="이름" persistent-placeholder hide-details/>
                    <v-row no-gutters align="center">
                        <v-col>
                            <v-select v-model="exchangeOrder.receiver.phone1" v-bind="$attrs" :items="phones" label="연락처" persistent-placeholder hide-details class="mt-4" />
                        </v-col>
                        <v-icon small class="mt-4">mdi-minus</v-icon>
                        <v-col>
                            <v-text-field v-model="exchangeOrder.receiver.phone2" v-bind="$attrs" hide-details maxlength="4" class="mt-4" />
                        </v-col>
                        <v-icon small class="mt-4">mdi-minus</v-icon>
                        <v-col>
                            <v-text-field v-model="exchangeOrder.receiver.phone3" v-bind="$attrs" hide-details maxlength="4" class="mt-4" />
                        </v-col>
                    </v-row>
                    <v-text-field v-model="exchangeOrder.receiver.email" label="이메일" persistent-placeholder hide-details class="mt-4" />
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">배송지 정보 입력</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" md="6" >
                            <v-text-field v-model="exchangeOrder.shippingAddress.postcode" v-bind="$attrs" label="우편번호" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                        </v-col>
                    </v-row>
                    <v-row class="mx-n3">
                        <v-col cols="12" md="6" :class="{ 'pb-0': $vuetify.breakpoint.mobile }">
                            <v-text-field v-model="exchangeOrder.shippingAddress.address1" v-bind="$attrs" label="기본주소" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="exchangeOrder.shippingAddress.address2" v-bind="$attrs" label="상세주소" persistent-placeholder hide-details />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card tile elevation="0" class="mt-4">
                <v-card-title class="tit tit--xs">요청사항</v-card-title>
                <v-card-text>
                    <v-textarea v-model="exchangeOrder.demand" label="배송 요청사항" outlined persistent-placeholder dense rows="3" hide-details/>
                </v-card-text>
            </v-card>

            <v-layout class="mt-4" justify-center>
                <v-btn x-large color="primary" elevation="0" @click="pay" class="mx-1">교환하기</v-btn>
                <v-btn x-large color="white" elevation="0" @click="$router.go(-1)" class="mx-1">취소하기</v-btn>
            </v-layout>

        </v-responsive>

        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => { exchangeOrder.shippingAddress.postcode = postcode; exchangeOrder.shippingAddress.address1 = address; } " />
        <!-- <kcp-pay ref="kcpPay" /> -->
    </component>
</template>
<script>
import api from "@/api";
import islands from "@/assets/data/islands.json";
import { mdiReceipt, mdiBookOpenPageVariant  } from "@mdi/js";
import PickupItem from "@/components/client/shop/order/pickup-item.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import KcpPay from "@/components/plugins/kcp/kcp-pay.vue";
export default {
    components: {
        PickupItem,
        DaumPostcode,
        KcpPay
    },
    data(){
        return {
            islands,
            mdiReceipt,
            mdiBookOpenPageVariant,

            aggreement: false,

            exchangeOrder: {
                _id: null,
                pickups: [],

                pno: null,

                buyer: {
                    _id: null,
                    name: null,

                    phone: null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,

                    email: null,
                },

                receiver: {
                    name: null,

                    phone:  null,
                    phone1: "010",
                    phone2: null,
                    phone3: null,

                    email: null,
                },

                shippingAddress: {
                    postcode: null,
                    address1: null,
                    address2: null
                },

                demand: null,
                message: null,

                point: 0,
                cash: 0,
            },

            carts: [],

            phones: ["010", "011", "016", "017", "019"],

            setting: null
        }
    },
    async mounted(){
        await this.init();
    },
    methods: {
        async init(){
            // 쇼핑몰 설정정보
            let { setting } = await api.v1.shop.setting.get();
            this.setting = setting;

            // 상품페이지 & 장바구니에서 픽업된 상품 로드
            let carts = this.$store.state.pickupItems;
            if(!carts.length){
                alert("구매하실 상품을 선택해주세요");
                this.$router.go(-1);
                return;
            }
            this.$store.dispatch("checkout");
            this.carts = carts;
            this.exchangeOrder.pickups = carts.map(cart => ({ _product: cart.product._id, quantity: cart.quantity }));

            //
            if(this.logon){
                let { me } = await api.v1.me.profile.get();
                let { _id, name, username, phone, email } = me;
                let [ phone1, phone2, phone3 ] = phone?.phoneNumberFormat?.()?.split?.('-') || [];

                this.$set(this.exchangeOrder, "buyer", {
                    _id,
                    name,
                    username,
                    phone, phone1, phone2, phone3,
                    email
                });

                this.$set(this.exchangeOrder, "shippingAddress", {
                    postcode,
                    address1,
                    address2
                });
            }
        },

        validate(){
            try{
                if(!this.exchangeOrder.pno) throw new Error("핀번호를 입력해주세요");
                if(!this.exchangeOrder.receiver.name) throw new Error("수취인 이름을 입력해주세요");
                if(!this.exchangeOrder.receiver.phone) throw new Error("수취인 연락처를 입력해주세요");
                if(!this.exchangeOrder.receiver.email) throw new Error("수취인 이메일을 입력해주세요");

                if(!this.exchangeOrder.shippingAddress.postcode) throw new Error("배송지 우편번호를 입력해주세요");
                if(!this.exchangeOrder.shippingAddress.address1) throw new Error("배송지 기본주소를 입력해주세요");
                if(!this.exchangeOrder.shippingAddress.address2) throw new Error("배송지 상세주소를 입력해주세요");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async pay(){
            if(this.validate()){
                let { exchangeOrder } = await api.v1.shop.exchangeOrders.post(this.exchangeOrder);
                this.$router.push(`/shop/exchange-result?_exchangeOrder=${exchangeOrder._id}`);
            }
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.shop}`); },

        accessToken(){
            return this.$store.state.accessToken;
        },

        logon(){
            return !!this.accessToken;
        },

        saleAmount(){
            return this.carts.reduce((saleAmount, cart) => saleAmount + cart.product.salePrice * cart.quantity, 0);
        },

        shippingAmount(){
            let pickups = this.carts;
            let shippingAmount = 0;
            let setting = this.setting;
            // 상품 배송정책
            shippingAmount += pickups.filter(pickup => pickup.product.shippingCode == "self").reduce((shippingAmount, pickup) => +pickup.product.shippingPrice + shippingAmount, 0);
            // 주문 배송정책
            let saleAmount = pickups.filter(pickup => pickup.product.shippingCode == "order").reduce((saleAmount, pickup) => saleAmount + pickup.product.salePrice * pickup.quantity, 0);
            if(pickups.some(pickup => pickup.product.shippingCode == "order")) shippingAmount += setting.saleAmount <= saleAmount ? setting.shippingPrice.gt : setting.shippingPrice.lt;
            return shippingAmount;
        },

        islandAmount(){
            let shippingAddress = this.exchangeOrder.shippingAddress;
            let islandAmount = 0;
            let setting = this.setting;
            let island = this.islands.find(island => {
                return island.areas.find(area => area.postcode == shippingAddress.postcode);
            });

            switch(island?.code){
                case "jeju": { islandAmount = parseInt(setting.islandPrice?.jeju || 0); break; }
                case "normal": { islandAmount = parseInt(setting.islandPrice?.normal || 0); break; }
            }

            return islandAmount;
        },

        totalAmount(){
            return this.saleAmount + this.shippingAmount;
        }
    },
    watch: {
        exchangeOrder: {
            deep: true,
            handler(value){
                var { phone1, phone2, phone3 } = value.buyer;
                value.buyer.phone = (phone1 && phone2 && phone3) ? `${phone1}${phone2}${phone3}`.phoneNumberFormat() : null;

                var { phone1, phone2, phone3 } = value.receiver;
                value.receiver.phone = (phone1 && phone2 && phone3) ? `${phone1}${phone2}${phone3}`.phoneNumberFormat() : null;
            }
        }
    }
}
</script>

<style scoped>
.row + .row {
    margin-top: 0px;
}
</style>